export default __webpack_public_path__ + "static/media/sharples_thumb.08bee65b.jpg";